<template>

    <tq-tabs v-else
             :p_tabs_ao="p_teamsTabs_ac"
             :p_tabs-notification_by-tab-index_n="co_teamNotification_byTeamTabIndex_n"
             class=" TQ_borderRadius_bottom TQ_margin_4px "
             p_att_s="gst_name_s"
             p_tabs-class_s="TQ_padding_8px TQ_text_20px"
             :p_system_lang-code_e="p_system_langCode_e"
             :p_selected-tab-index_vn="p_selectedTabIndex_vn">

        <!-- title -->
        <div class="TQ_bg_purple_lite TQ_padding_8px TQ_text_24px">
            <div v-if="selectedRiddleIndex_n == null">
                {{ass_strings.twoWords_cardsMissions[p_system_langCode_e]}}
            </div>

            <div v-else class="TQ_grid_col_1frAuto">
                <div class="TQ_grid_verticalCenter">
                    {{ass_strings.twoWords_cardMission[p_system_langCode_e]}}
                </div>

                <img :src="ass_img_leftArrow_w"
                     class="TQ_width_28px TQ_grid_verticalCenter"
                     @click="selectedRiddleIndex_n = null"/>
            </div>

        </div>

        <!-- body -->
        <div class="TQ_scrollable TQ_height_450px">

            <!-- cards name list -->
            <div v-if="selectedRiddleIndex_n == null" class="TQ_bg_gray4 TQ_padding_4px">

                <div v-for="missionIndex_n in co_currentTeam_missionsArrangementIndexes_an"
                     class="TQ_margin_8px_0 TQ_grid_col_1frAuto TQ_box_shadow">
                    <div class="TQ_bg_white TQ_padding_16px TQ_text_20px  TQ_bg_hover_goldLite TQ_clickable"
                         @click="selectedRiddleIndex_n=missionIndex_n">
                        {{p_questBody_c.qb_cardsMissions_ac[missionIndex_n].qbr_title_blc_s[p_questBody_c.cm_qb_getDisplayLangCode_e(p_system_langCode_e)]}}
                    </div>

                    <div class="TQ_text_20px TQ_padding_16px TQ_bg_gold" v-if="co_currentTeam_missionsNotification_byRiddleIndex_n[missionIndex_n] > 0">
                        {{co_currentTeam_missionsNotification_byRiddleIndex_n[missionIndex_n]}}
                    </div>
                    <div v-else-if="co_currentTeam_missionsNotification_byRiddleIndex_n[missionIndex_n] === -1" class="TQ_bg_green TQ_padding_8px">
                        <img :src="ass_img_checked_w"
                             class="TQ_width_24px TQ_height_100p"
                             @click="selectedRiddleIndex_n = null"/>
                    </div>

                </div>
            </div>

            <!-- card mission-->
            <div v-else>

                <tq-riddle-data_war-room
                    v-if="p_questBody_c.qb_cardsMissions_ac[selectedRiddleIndex_n]"
                    class="TQ_padding_8px TQ_bg_white"

                    :p_name_s="selectedRiddleIndex_n + ''"
                    :p_qb_display-lang-code_e="p_questBody_c.cm_qb_getDisplayLangCode_e(p_system_langCode_e)"

                    :p_qb_riddle_c="p_questBody_c.qb_cardsMissions_ac[selectedRiddleIndex_n]"
                    :p_riddle-status_c="co_currentTeam_allMissionsStatus_byRiddleIndex_c[selectedRiddleIndex_n]"
                    :p_qb_metadata_c="p_questBody_c.qb_metadata_c"

                    :p_clues-left_n="0"

                    :pe_update-lock-status_f="m_userEvent_updateCardMission_LockStatus"
                />

            </div>

        </div>

    </tq-tabs>


</template>

<script>
    import TqRiddleData_warRoom from "../../../../components/complex/TqRiddleData_WarRoom";
    import TqTabs from "../../../../components/basic/TqTabs";
    import {validator_enum_fb} from "../../../../../functions/src/shareCode/Share_S_Validator";
    import {obj_forEach_f} from "../../../../../functions/src/shareCode/Share_S_Obj";
    import {enum_langCodes,enum_lockTypes, enum_lockState, enum_subCollection_teamStatus} from "../../../../../functions/src/shareCode/Share_S_Enum";
    import {helper_finishLock_fb} from "../../../../scripts/S_Helper";
    import {ass_strings} from "../../../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {FB_GameStatus, FB_QuestBody, FB_QuestEvent} from "../../../../../functions/src/shareCode/Share_S_Classes";
    import {
        ass_img_checked_w,
        ass_img_arrow_left_w
    } from "../../../../assets/scripts/Ass_Files";

    export default {
        name: "c_Creator_Events_Item_CardsMissions",
        components: {TqTabs, TqRiddleData_warRoom},
        props:{
            p_system_langCode_e:{
                type: String,
                require: true,
                validator(langCode){
                    return validator_enum_fb(enum_langCodes, langCode)
                }
            },
            p_questEvent_c : {
                type:FB_QuestEvent,
                require:true,
            },
            p_questBody_c:{
                type:FB_QuestBody,
                require:true,
            },
            p_gameStatus_c:{
                type : FB_GameStatus,
                require: true
            },
            p_teamId_uid:{
                type: String,
                require: true,
            },

            p_selectedTabIndex_vn : {
                type:Object,
                require: true
            },
            p_teamsTabs_ac:{
                type:Array,
                require: true
            },

            pe_updateTeamStatus_riddleStatus_unlock_status:{
                type:Function,
                require: true,
            },

        },
        data(){
            return {
                selectedRiddleIndex_n           : null,
                missionsNotification_byTeamId_byRiddleIndex_n: {},
                teamNotification_byTeamId_n: {},

                // server
                server_ts_allCardsMissions_byTeamId_byRiddleIndex_c : {},

                // import
                ass_img_leftArrow_w             : ass_img_arrow_left_w,
                ass_img_checked_w               : ass_img_checked_w,
                ass_strings                     : ass_strings,
            }
        },
        computed:{
            co_currentTeam_allMissionsStatus_byRiddleIndex_c(){
                if(this.server_ts_allCardsMissions_byTeamId_byRiddleIndex_c[this.p_teamId_uid] == null){
                    this.$set(this.server_ts_allCardsMissions_byTeamId_byRiddleIndex_c, this.p_teamId_uid, {})
                }
                return this.server_ts_allCardsMissions_byTeamId_byRiddleIndex_c[this.p_teamId_uid]
            },
            co_currentTeam_missionsNotification_byRiddleIndex_n(){
                if(this.missionsNotification_byTeamId_byRiddleIndex_n[this.p_teamId_uid] == null){
                    this.$set(this.missionsNotification_byTeamId_byRiddleIndex_n, this.p_teamId_uid, {})
                }

                return this.missionsNotification_byTeamId_byRiddleIndex_n[this.p_teamId_uid]
            },
            co_teamNotification_byTeamTabIndex_n(){
                let ans = {}

                this.p_teamsTabs_ac.forEach((gs_team_c, teamIndex_n) => {
                    ans[teamIndex_n] = this.teamNotification_byTeamId_n[gs_team_c.gst_teamId_uid]
                })

                return ans
            },
            co_qb_cardsMissionsIndexes_byRiddleId_n(){

                let ans = {}

                this.p_questBody_c.qb_cardsMissions_ac.forEach((qb_riddle_c,index_n) => {
                    ans[qb_riddle_c.qbr_riddleId_n] = index_n
                })

                return ans
            },

            co_currentTeam_missionsArrangementIndexes_an(){

                if(this.p_gameStatus_c.gs_teams_byTeamId[this.p_teamId_uid] == null){
                    return []
                }

                let missionsArrangementIndex_n = this.p_gameStatus_c.gs_teams_byTeamId[this.p_teamId_uid].gst_missionsArrangementIndex_n
                return this.p_questBody_c.cm_qb_getMissionsArrangement_an(missionsArrangementIndex_n, enum_subCollection_teamStatus.CARDS_MISSIONS)
            }
        },
        methods: {

            // localFunctions
            m_userEvent_updateCardMission_LockStatus(lockIndex_n, lockData_c, lockStatus_e, cb_f){

                let riddleId_n = this.p_questBody_c.qb_cardsMissions_ac[this.selectedRiddleIndex_n].qbr_riddleId_n

                this.pe_updateTeamStatus_riddleStatus_unlock_status(riddleId_n, lockIndex_n, lockData_c, lockStatus_e, cb_f)

            },
            m_updateMissionsNotification_f(teamId_uid, riddleIndex_n, riddleStatus_c){

                // if(riddleStatus_c == null || riddleStatus_c.rs_unlock_byLockId_c == null) {return}

                const qb_riddle_c = this.p_questBody_c.qb_cardsMissions_ac[riddleIndex_n]
                let notification_n = 0
                let finishCurrentRiddle_b = true

                qb_riddle_c.qbr_locks_ac.forEach((qbr_lock_c,lockIndex_c) => {
                    const rs_unlockData_c = riddleStatus_c.rs_unlock_byLockId_c[lockIndex_c]
                    const finishLock_b = helper_finishLock_fb(riddleStatus_c, lockIndex_c, qb_riddle_c.qbr_locks_ac[lockIndex_c].qbrl_type_e )

                    if (!finishLock_b
                        && [enum_lockTypes.VIDEO, enum_lockTypes.IMAGE].includes(qbr_lock_c.qbrl_type_e)
                        && rs_unlockData_c && rs_unlockData_c.rsud_lockState_e !== enum_lockState.approved) {

                        notification_n++
                    }
                    finishCurrentRiddle_b = finishCurrentRiddle_b && finishLock_b
                    
                })


                if(finishCurrentRiddle_b){
                    notification_n = -1
                }

                // update mission notification
                if(this.missionsNotification_byTeamId_byRiddleIndex_n[teamId_uid] == null){
                    this.$set(this.missionsNotification_byTeamId_byRiddleIndex_n, teamId_uid, {})
                }
                this.$set(this.missionsNotification_byTeamId_byRiddleIndex_n[teamId_uid], riddleIndex_n, notification_n)

                // update team notification
                let teamNotification_n = 0
                obj_forEach_f(this.missionsNotification_byTeamId_byRiddleIndex_n[teamId_uid], missionsNotification_n => {
                    if(missionsNotification_n > 0){
                        teamNotification_n += missionsNotification_n
                    }
                })
                this.$set(this.teamNotification_byTeamId_n, teamId_uid, teamNotification_n);
            },

            // mRef
            mRef_updateRiddleStatus_f(enum_subCollectionName_e, teamId_uid, riddleStatus_c){

                if(this.server_ts_allCardsMissions_byTeamId_byRiddleIndex_c[teamId_uid] == null){
                    this.$set(this.server_ts_allCardsMissions_byTeamId_byRiddleIndex_c, teamId_uid, {})
                }

                let cardRiddleIndex_n = this.co_qb_cardsMissionsIndexes_byRiddleId_n[riddleStatus_c.rs_riddleId_n]

                this.$set(this.server_ts_allCardsMissions_byTeamId_byRiddleIndex_c[teamId_uid], cardRiddleIndex_n, riddleStatus_c)

                this.m_updateMissionsNotification_f(teamId_uid, cardRiddleIndex_n, riddleStatus_c)

            }
        },
    }
</script>

<style scoped>

</style>